(() => {
  let queued = false;
  const update = () => {
    queued = false;
    const bar = document.getElementById('PBarNextFrame');
    const rect = bar?.getBoundingClientRect();
    const shown = bar && getComputedStyle(bar).visibility !== 'hidden' && getComputedStyle(bar).display !== 'none';
    const covered = shown && rect.height > 0 && rect.bottom >= window.innerHeight - 2 ? Math.max(0, window.innerHeight - rect.top) : 0;
    const viewport = window.visualViewport;
    const keyboard = viewport ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop) : 0;
    // Shopify preview uses a viewport-sized iframe, not the visible toolbar height.
    // Bound this breathing room so checkout cannot scroll away above a blank screen.
    const value = `${Math.min(48, Math.max(covered, keyboard))}px`;
    if (document.documentElement.style.getPropertyValue('--wcl-bottom-obstruction') !== value) document.documentElement.style.setProperty('--wcl-bottom-obstruction', value);
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  window.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('scroll', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden', 'class'] });
  schedule();
})();
